<div class="patient-login-info">
  <a (click)="toggle()" class="expand-icon"><i class="far fa-info-circle" *ngIf="!isOpen"></i><i class="far fa-times"
      *ngIf="isOpen"></i></a>

  <div class="row" *ngIf="patient && isOpen">
    <div class="col-12">
      <div class="patient-info-grid">
        <div class="box-label study-phase-box" *ngIf="patient.trialBrand?.toLowerCase() === 'adarx'">
          <div class="study-phase-body" [class.is-loading]="recalculating">
            <ng-container *ngIf="!recalculating; else recalculatingTpl">
              <div class="study-phase-header">
                <label>Phase: {{ patient.studyPhase || '-' }}</label>
                <button type="button" class="icon-button" [disabled]="!patient?.patientTrialId"
                  aria-label="Recalculate study phase" (click)="recalculateStudyPhase()">
                  <i class="fas fa-redo"></i>
                </button>
              </div>
              <p *ngIf="getStudyPhaseDate()">
                <strong>Started:</strong>
                {{ getStudyPhaseDate() | date: 'd MMM yyyy' }} at {{ getStudyPhaseDate() | date: 'h:mm aaa' }}
              </p>
            </ng-container>
            <ng-template #recalculatingTpl>
              <div class="study-phase-status">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="status-text">Recalculating</span>
              </div>
            </ng-template>
          </div>
        </div>

        <div class="box-label">
          <label>Last Login</label>
          <p>{{ patient.lastLoginDate | date: 'd MMM yyyy'}} at {{ patient.lastLoginDate | date: 'h:mm aaa' }}</p>
        </div>

        <div class="box-label">
          <label>Password Set</label>
          <p>{{ patient.passwordSetDate | date: 'd MMM yyyy'}} at {{ patient.passwordSetDate | date: 'h:mm aaa' }}</p>
        </div>

        <div class="box-label">
          <label>Registered</label>
          <p>{{ patient.registeredDate | date: 'd MMM yyyy'}} at {{ patient.registeredDate | date: 'h:mm aaa' }}</p>
        </div>

        <div class="box-label">
          <label>Platform/Version</label>
          <p>{{ patient.platform ? patient.platform : '-' }} {{ patient.appVersion ? patient.appVersion: '' }}</p>
        </div>

        <div class="box-label">
          <label>Device</label>
          <p>{{ patient.device ? patient.device : '-' }}</p>
        </div>
      </div>
    </div>
  </div>
</div>